import type { CountryCode } from '@acceligentllc/shared/enums/countryCode';

import type UserOS from 'ab-enums/userOS.enum';

export interface FinalizeUser {
	password: string;
	repeatedPassword?: string; // Only on FE
	confirmedPrivacyPolicy?: boolean;
	confirmedToReceiveWorkNotifications?: boolean;
}

export interface ResetPassword {
	password: string;
	repeatedPassword?: string;
	email: string;
	activationCode: string;
	orgAlias: string;
}

export class UserEmailCredentials {
	email: string;
	password: string;
	orgAlias: string;
	device: {
		deviceOS: Nullable<UserOS>;
		ipAddress: Nullable<string>;
		ipLocation: Nullable<string>;
		signedAt: Date;
		lastAccessedAt: Date;
	};

	constructor(email: string, password: string, orgAlias: string) {
		this.email = email;
		this.password = password;
		this.orgAlias = orgAlias;
	}
}

export class UserEmailLMSCredentials {
	email: string;
	password: string;
	orgAlias: string;
	authnRequestId: string;

	constructor(email: string, password: string, orgAlias: string, authnRequestId: string) {
		this.email = email;
		this.password = password;
		this.orgAlias = orgAlias;
		this.authnRequestId = authnRequestId;
	}
}

export interface UserPhoneCode {
	activationCode: string;
}

export interface UserPhoneCredentials extends UserPhoneCode {
	phoneNumber: string;
	countryCode: CountryCode;
	activationCode: string;
	orgAlias: string;
}

export type UserCredentials = UserEmailCredentials & UserPhoneCredentials;

export interface PasswordForgotten {
	email: string;
	orgAlias: string;
}
